import L from "leaflet";
import "./index.js";
import china from "./china.json";
// import test from "./test.json";
import normal from "./ditu.js";
import legendColor from "./legendColor.json";
// import legendVue from "@/page/legend.vue";
import mapimg from "@/assets/map/mapExport.js";
class MapCreate {
  constructor(map, mapData, mapLegend, mapLegendData) {
    this.map = null;
    // this.mapData = mapData;
    // this.mapLegend = mapLegend;
    // this.mapLegendData = mapLegendData;
  }
  init() {
    this.map = L.map("map", {
      center: [32, 104.3],  // 初始中心点
      zoom: 3.5,  // 初始化地图缩放级别
      minZoom: 1, //最小级别
      maxZoom: 20,  //最大缩放级别
      zoomSnap: 0.5, //强制让地图的缩放级别始终为这个值的倍数
      zoomDelta: 0.5, //地图缩放级别改变的值
      doubleClickZoom: false, //双击放大
      // layers: [normal.Gaode], //添加图层
      zoomControl: false, //是否显示缩放控件
      attributionControl: false,  //是否显示右下角的attribution
      wheelPxPerZoomLevel: 100, //较小的值将使滚轮变焦更快 多少滚动像素
      padding: [100, 100]
    });
    // var scale = L.control.scale();
    // //将比例尺控件加载到地图容器中
    // this.map.addControl(scale)
    this.map.doubleClickZoom.enable()
    const scaleControll = L.control.scale().addTo(this.map);
    scaleControll.setPosition('bottomright')
    // scaleControll.getContainer().style.position = "absolute"
    scaleControll.getContainer().style.right = "86vw"
    scaleControll.getContainer().style.bottom = "10px"

    // console.log();
    L.tileLayer(
      "http://webrd01.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=7&x={x}&y={y}&z={z}",
    ).addTo(this.map);


    //地图切换控件 img设置
    const vector = `<img class='my-layer-img' src='${mapimg.vector}' /> <div class='my-layer-item'>行政图</div>`;
    const satellitepoi = `<img class='my-layer-img' src='${mapimg.satellitepoi}' /> <div class='my-layer-item'>影像图</div>`;
    const terrain = `<img class='my-layer-img' src='${mapimg.terrain}' /> <div class='my-layer-item'>地形图</div>`;
    //新建图层控件的数据源-地图
    const baseLayers = {
      [vector]: normal.Gaode,
      [satellitepoi]: normal.image,
      [terrain]: normal.terrain,

    };

    //新建图层控件的数据源-工具
    // const overlays = {
    //   地图工具: normal.tool,
    // };
    const layerControl = L.control.layers(baseLayers).addTo(this.map);
    //地图切换控件 img设置
    layerControl.setPosition('topleft')
    layerControl._baseLayersList.style.display = "flex";
    layerControl._baseLayersList.querySelectorAll("label").forEach((item) => {
      item.style.position = "relative";
      item.style.marginLeft = "5px";
      item.querySelector("input").style.cssText =
        "position:absolute;top:0;z-index:1; ";
    });
    // layerControl.getContainer().style.position = "absolute";
    // layerControl.getContainer().style.top = "25px";
    // layerControl.getContainer().style.left = "25px";


    const style = {
      color: "#000", //线颜色
      weight: 2, //线粗细
      opacity: 1, //透明度
      fillColor: "#fff", //区域填充颜色
      fillOpacity: 0, //区域填充颜色的透明
    };
    L.geoJSON(china.features, { style: style }).addTo(this.map);
    return this.map
  }
  flyToCneter(data, zoom) {
    this.map.flyTo(data, zoom)
  }
  mapBorder() {
    //铁路线路
    const Lon = [103.977, 103.4974, 103.0555, 101.963, 100.2901, 97.8408, 95.7676, 94.3636, 91.1377,];
    const Lat = [30.678, 30.1893, 30.0262, 30.0538, 29.9833, 29.6709, 29.859, 29.6421, 29.6526,];
    let data = [];
    Lon.forEach((element, index) => {
      data.push([Lat[index], element]);
    });
    L.polyline(data, {
      color: "black",
      weight: 2,
      className: "dashLines",
    }).addTo(this.map);
    /* 这里分为两个写是因为，层级问题 */
    Lon.forEach((element, index) => {
      L.circleMarker(new L.LatLng(...data[index]), {
        // 创建点 (38, 107)为经纬度
        color: "#0302f1", //线颜色
        weight: 2, //线宽度
        opacity: 1, //透明度
        fillColor: "#0302f1", //填充色
        fillOpacity: 1, //填充透明度
        radius: 5, //半径
      }).addTo(this.map);
    });
    let bounds = [[28, 106], [32, 89],];
    // 创建一个蓝色色的矩形
    L.rectangle(bounds, {
      color: "#0302f1",
      weight: 3,
      fillColor: "#fff",
      fillOpacity: 0,
    }).addTo(this.map);

    // map.fitBounds(bounds);
    //显示文字
    const position = [[28, 106], [32, 89], [28, 89], [32, 106],];
    position.forEach((res, index) => {
      const myIcon = L.divIcon({
        className: "rectangleLatlng",
        html: `<div class='my-div'>${res[1]}°E,${res[0]}°N</div>`,
      });
      L.marker(res, { icon: myIcon }).addTo(this.map);
    });
  }
}
export {
  L,
  legendColor,
  // legendVue,
  mapimg,
  MapCreate
};
